import { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import { AvField, AvForm } from "availity-reactstrap-validation";
import uploadImg from "../../../../images/upload-img.png";
import "../style.scss";
import { toast } from "react-toastify";
import BaseService from "../../../../services/BaseService";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../common/Loader";
import { Translate } from "../../../Enums/Tranlate";
import CategoriesService from "../../../../services/CategoriesService";
import ProductsService from "../../../../services/ProductsService";
import { loadingToggleAction } from "../../../../store/actions/AuthActions";
import SubCategoriesService from "../../../../services/SubCategoriesService";

const AddProducts = () => {
	const [product, setProduct] = useState({
		name_en: "",
		name_ar: "",
		amount: "",
		description_en: "",
		description_ar: "",
		bestSeller: false,
		newIn: false,
		sub_category: "",
		offer: false,
		offerPrice: "",
		price: "",
		category: "",
		brand: "",
		code: "",
		cost: "",
		images: [
			{ src: "", loading: false },
			{ src: "", loading: false },
			{ src: "", loading: false },
			{ src: "", loading: false },
			{ src: "", loading: false },
			{ src: "", loading: false },
		],
	});
	const [errors, setErrors] = useState({
		desc_ar: false,
		desc_en: false,
		images: 0,
	});
	const dispatch = useDispatch();
	const [id, setId] = useState(null);
	const [loading, setLoadning] = useState(false);
	const [view, setView] = useState(false);
	const [categoriesOptions, setCategoriesOptions] = useState([]);
	const [subCategoriesOptions, setSubCategoriesOptions] = useState([]);
	const navigate = useNavigate();
	const location = useLocation();
	const categoriesService = new CategoriesService();
	const productsService = new ProductsService();
	const subCategoriesService = new SubCategoriesService();
	const Auth = useSelector((state) => state.auth);
	const lang = useSelector((state) => state.auth.lang);

	useEffect(() => {
		categoriesService.getList().then((res) => {
			if (res?.status === 200) {
				let categories = res.data?.data?.data?.map((item) => {
					return {
						id: item?.id,
						value: item?.id,
						label: lang === "en" ? item.name_en : item.name_ar,
					};
				});
				setCategoriesOptions(categories);
			}
		});
	}, [lang]);

	useEffect(() => {
		if (!!product?.category) {
			subCategoriesService
				.getListForCategory(product?.category?.id)
				.then((res) => {
					if (res?.data?.status === 200) {
						let subCategories = res.data?.data?.data?.map((item) => {
							return {
								id: item?.id,
								value: item?.id,
								label: lang === "en" ? item.name_en : item.name_ar,
							};
						});
						setSubCategoriesOptions(subCategories);
					}
				});
		}
	}, [product?.category]);

	useEffect(() => {
		setView(location?.state?.view);

		let prod_id = window.location.pathname.split("/products/add-products/")[1];
		setId(Number(prod_id));

		if (!!prod_id) {
			let obj = {};
			let prod = productsService.getProduct(prod_id);
			dispatch(loadingToggleAction(true));
			Promise.all([prod]).then((res) => {
				let data = {};
				if (res[0]?.status === 200) {
					let response = res[0].data?.data;
					data = {
						...response?.product,
						offerPrice: !!response.product.offerPrice
							? Number(response.product.offerPrice)
							: "",
						category: {
							...response?.product.category,
							id: response?.product.category_id,
							value: response.product?.category_id,
							label:
								lang === "en"
									? response.product?.category?.name_en
									: response.product?.category?.name_ar,
						},
						sub_category: response.product?.sub_category?.name_en
							? {
									...response.product?.sub_category,
									label:
										lang === "en"
											? response.product?.sub_category?.name_en
											: response.product?.sub_category?.name_ar,
									value: response.product?.sub_category_id,
									id: response.product?.sub_category_id,
							  }
							: "",
						brand: !!response?.product.brand
							? {
									...response?.product.brand,
									id: response?.product.brand_id,
									value: response.product?.brand_id,
									label:
										lang === "en"
											? response.product?.brand?.name_en
											: response.product?.brand?.name_ar,
							  }
							: "",
						images: product?.images?.map((_, index) => {
							if (!!response.product.product_images[index]?.url) {
								return {
									src: response.product.product_images[index]?.url,
								};
							} else {
								return {
									src: "",
								};
							}
						}),
					};
				}

				setProduct({ ...data });
				dispatch(loadingToggleAction(false));
			});
		}
	}, []);

	const fileHandler = (e, index) => {
		let filesAll = e.target.files;
		const filesData = Object.values(filesAll);
		console.log(filesData);
		if (!!filesData?.length) {
			setProduct((prev) => ({
				...prev,
				images: prev?.images?.map((item, ind) =>
					index === ind ? { ...item, loading: true } : item
				),
			}));
			new BaseService().postUpload(filesData[0]).then((res) => {
				if (res?.data?.status) {
					setProduct((prev) => ({
						...prev,
						images: prev?.images?.map((item, ind) =>
							index === ind ? { src: res.data.url, loading: false } : item
						),
					}));
				}
			});
		}
	};

	const handlerText = (e) => {
		setProduct({ ...product, [e.target.name]: e.target.value });
	};

	const submit = () => {
		if (!product.description_ar || !product.description_en) {
			setErrors({
				desc_ar: !product.desc_ar,
				desc_en: !product.desc_en,
			});
			return;
		}
		if (product?.images?.filter((res) => !!res?.src)?.length === 0) {
			toast.error("Upload Images");
			return;
		}

		setLoadning(true);
		let data = {
			name_en: product.name_en,
			name_ar: product.name_ar,
			code: product.code,
			category_id: product.category?.value,
			images: product?.images
				?.filter((res) => !!res?.src)
				?.map((item) => item?.src),
			description_en: product.description_en,
			description_ar: product.description_ar,
			bestSeller: product.bestSeller,
			newIn: product.newIn,
			offer: product.offer,
			amount: product.amount,
			price: parseFloat(product.price),
			cost: parseFloat(product.cost),
		};

		if (!!product?.brand) data["brand_id"] = product?.brand?.value;
		if (!!product.sub_category)
			data["sub_category_id"] = product?.sub_category?.value;
		if (!!product.offerPrice) data["offerPrice"] = product.offerPrice;

		if (!!id) {
			productsService
				.update(id, data)
				?.then((res) => {
					if (res.data?.status === 200) {
						toast.success("Product Updated Successfully");
						navigate(`/products`);
					}
					setLoadning(false);
				})
				.catch((e) =>
					toast.error(e.response?.data?.message?.replaceAll("_", " "))
				);
		} else {
			data["all_image"] = true;
			data["all_price"] = true;
			data["all_cost"] = true;
			productsService
				.create(data)
				?.then((res) => {
					if (res.data?.status === 201) {
						toast.success("Product Added Successfully");
						navigate("/products");
					}
					setLoadning(false);
				})
				.catch((e) =>
					toast.error(e.response?.data?.message?.replaceAll("_", " "))
				);
		}
	};

	const deleteImg = (index) => {
		setProduct((prev) => ({
			...prev,
			images: prev?.images.map((item, ind) =>
				ind === index ? { ...item, src: "" } : item
			),
		}));
	};

	if (Auth.showLoading) {
		return (
			<Card className="p-4" style={{ minHeight: "30rem" }}>
				<Loader />
			</Card>
		);
	}
	return (
		<Card className="p-4">
			<AvForm onValidSubmit={submit} className="add-product">
				<Row>
					<Col md={6} className="mb-3">
						<AvField
							label={`${Translate[lang]?.english_title}*`}
							type="text"
							placeholder={Translate[lang]?.english}
							bsSize="lg"
							name="name_en"
							disabled={view}
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							value={product.name_en}
							onChange={(e) => handlerText(e)}
						/>
					</Col>
					<Col md={6} className="mb-3">
						<AvField
							label={`${Translate[lang]?.arabic_title}*`}
							type="text"
							placeholder={Translate[lang]?.arabic}
							value={product.name_ar}
							name="name_ar"
							disabled={view}
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							onChange={(e) => handlerText(e)}
						/>
					</Col>
					<Col md={6} className="mb-3">
						<label className="text-label">
							{Translate[lang]?.english_description}*
						</label>
						<textarea
							name="description_en"
							disabled={view}
							style={{
								minHeight: "80px",
								maxHeight: "150px",
								height: "150px",
							}}
							className="form-control"
							required
							placeholder={Translate[lang]?.english}
							value={product.description_en}
							onChange={(e) => {
								setErrors({
									...errors,
									desc_en: false,
								});
								handlerText(e);
							}}
							rows="6"></textarea>
						{errors["desc_en"] && (
							<p className="text-danger m-0" style={{ fontSize: "12.8px" }}>
								{Translate[lang].field_required}
							</p>
						)}
					</Col>
					<Col md={6} className="mb-3">
						<label className="text-label">
							{Translate[lang]?.arabic_description}*
						</label>
						<textarea
							name="description_ar"
							disabled={view}
							style={{
								minHeight: "80px",
								maxHeight: "150px",
								height: "150px",
							}}
							className="form-control"
							placeholder={Translate[lang]?.arabic}
							value={product.description_ar}
							onChange={(e) => {
								setErrors({
									...errors,
									desc_ar: false,
								});
								handlerText(e);
							}}
							rows="6"></textarea>
						{errors["desc_ar"] && (
							<p className="text-danger m-0" style={{ fontSize: "12.8px" }}>
								{Translate[lang].field_required}
							</p>
						)}
					</Col>
					<Col md={6} sm={6} className="mb-3">
						<label className="text-label">{Translate[lang]?.category}*</label>
						<Select
							value={product.category}
							name="category"
							placeholder={Translate[lang]?.select}
							options={!view ? categoriesOptions : []}
							onChange={(e) =>
								setProduct({
									...product,
									category: e,
								})
							}
						/>
					</Col>
					<Col md={6} sm={6} className="mb-3">
						<label className="text-label">
							{Translate[lang]?.sub_categories}
						</label>
						<Select
							value={product?.sub_category}
							name="sub_category"
							placeholder={Translate[lang]?.select}
							options={subCategoriesOptions}
							onChange={(e) => setProduct({ ...product, sub_category: e })}
						/>
					</Col>
					{/* <Col md={6} sm={6} className="mb-3">
						<label className="text-label">{Translate[lang]?.brand}</label>
						<Select
							value={product.brand}
							name="brand"
							placeholder={Translate[lang]?.select}
							options={!view ? brandsOptions : []}
							onChange={(e) =>
								setProduct({
									...product,
									brand: e,
								})
							}
						/>
					</Col> */}
					<Col md={6} sm={6} className="mb-3">
						<AvField
							label={Translate[lang]?.code}
							type="text"
							placeholder={Translate[lang]?.code}
							bsSize="lg"
							name="code"
							disabled={view}
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							value={product.code}
							onChange={(e) => handlerText(e)}
						/>
					</Col>
					<Col md={3} sm={6} className="mb-3">
						<AvField
							label={`${Translate[lang]?.price}*`}
							type="number"
							placeholder={Translate[lang]?.price}
							bsSize="lg"
							name="price"
							min="0.0000000000001"
							disabled={view}
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							value={product.price}
							onChange={(e) => handlerText(e)}
						/>
					</Col>
					<Col md={3} sm={6} className="mb-3">
						<AvField
							label={`${Translate[lang]?.cost}*`}
							type="number"
							placeholder={Translate[lang]?.cost}
							bsSize="lg"
							disabled={view}
							name="cost"
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							min="0.0000000000001"
							value={product.cost}
							onChange={(e) => handlerText(e)}
						/>
					</Col>
					<Col md={3} sm={6} className="mb-3">
						<AvField
							label={`${Translate[lang]?.quantity}*`}
							type="number"
							placeholder={Translate[lang]?.quantity}
							bsSize="lg"
							disabled={view}
							name="amount"
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							min="1"
							value={product.amount}
							onChange={(e) => handlerText(e)}
						/>
					</Col>
					<Col md={3} sm={6} className="mb-3">
						<AvField
							label={Translate[lang]?.offer_price}
							type="number"
							placeholder={Translate[lang]?.offer_price}
							min="0.0000000000001"
							bsSize="lg"
							validate={{
								required: {
									value: product.offer,
									errorMessage: Translate[lang].field_required,
								},
							}}
							disabled={view}
							name="offerPrice"
							value={product.offerPrice}
							onChange={(e) => handlerText(e)}
						/>
					</Col>
					<Col md={2} sm={3} className="mb-3">
						<label className="text-label">{Translate[lang]?.best_seller}</label>
						<Form.Check
							type="switch"
							id={`bestSeller`}
							disabled={view}
							checked={product.bestSeller}
							onChange={(e) =>
								setProduct({ ...product, bestSeller: e.target.checked })
							}
						/>
					</Col>
					<Col md={2} sm={3} className="mb-3">
						<label className="text-label">{Translate[lang]?.new_in}</label>
						<Form.Check
							type="switch"
							id={`newIn`}
							disabled={view}
							checked={product.newIn}
							onChange={(e) =>
								setProduct({ ...product, newIn: e.target.checked })
							}
						/>
					</Col>
					<Col md={2} sm={3} className="mb-3">
						<label className="text-label">{Translate[lang]?.offer}</label>
						<Form.Check
							type="switch"
							id={`offer`}
							disabled={view}
							checked={product.offer}
							onChange={(e) =>
								setProduct({ ...product, offer: e.target.checked })
							}
						/>
					</Col>
				</Row>

				<label className="text-label mb-0" style={{ marginLeft: "8px" }}>
					{Translate[lang]?.images} ( 475*470 )
				</label>
				<Row>
					{console.log(product?.images)}
					{product?.images?.map((data, index) => {
						if (view && !data?.src) {
							return <></>;
						}
						return (
							<Col md={2} sm={4} className="mb-3" key={index}>
								<div className="image-placeholder">
									{!view && (
										<div className="avatar-edit">
											<input
												type="file"
												disabled={view}
												onChange={(e) => fileHandler(e, index)}
												id={`imageUpload${index}`}
											/>
											<label htmlFor={`imageUpload${index}`} name=""></label>
										</div>
									)}
									{!!data.src && !view && (
										<button
											className="delete-img"
											type="button"
											disabled={view}
											onClick={() => deleteImg(index)}>
											<i className="la la-trash"></i>
										</button>
									)}
									<div className="avatar-preview">
										{!!data.src && !data?.loading ? (
											<div id={`imagePreview${index}`}>
												<img
													id={`saveImageFile${index}`}
													src={data?.src}
													alt="icon"
												/>
											</div>
										) : (
											<div id={`imagePreview${index}`}>
												{data?.loading ? (
													<Loader />
												) : (
													<img
														src={uploadImg}
														alt="icon"
														style={{
															width: "60px",
															height: "60px",
														}}
													/>
												)}
											</div>
										)}
									</div>
								</div>
							</Col>
						);
					})}
				</Row>

				<div className="d-flex justify-content-between mt-4">
					<Button
						variant="secondary"
						type="button"
						onClick={() => navigate("/products")}>
						{Translate[lang]?.cancel}
					</Button>
					{!view && (
						<Button variant="primary" loading={loading} type="submit">
							{Translate[lang]?.submit}
						</Button>
					)}
				</div>
			</AvForm>
		</Card>
	);
};

export default AddProducts;
